import { useCallback, useEffect } from "react"

import { RefetchIntervals } from "../../../../../../core/api/refetchIntervals"
import { useInterval } from "../../../../../../shared/hooks/useInterval"

import { useRefreshCalendar } from "./RefreshCalendarProvider"

type UseTimelineAutoRefreshArgs = Readonly<{
    /** Called at tick time, so it may read refs that change without a render. */
    shouldSkipRefresh?: () => boolean
}>

/** Event sources otherwise only refetch on date navigation, so a long-open dialog goes stale. */
export function useTimelineAutoRefresh({ shouldSkipRefresh }: UseTimelineAutoRefreshArgs = {}) {
    const { triggerThrottledRefetch } = useRefreshCalendar()

    const refresh = useCallback(() => {
        if (document.hidden) return
        if (shouldSkipRefresh?.()) return

        triggerThrottledRefetch()
    }, [shouldSkipRefresh, triggerThrottledRefetch])

    useInterval(refresh, RefetchIntervals.long)

    useEffect(() => {
        document.addEventListener("visibilitychange", refresh)
        return () => document.removeEventListener("visibilitychange", refresh)
    }, [refresh])
}
